import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    DeletePopHover,
    Typography,
    Form,
    message,
    Modal,
    Input,
    setParamsFilter,
    Card,
    Select,
    Switch,
    Textarea,
    Radio,
    Tabs,
    InputNumber,
    DatePicker
} from "../../../ui/ot";
import { useCRUDController } from "../../../ui/classify_structure/CRUDController"
import { useTranslation } from "react-i18next";
import parse from 'html-react-parser';

const SerialCodeManagement = (
    permission_level = null, 
) => {
    return (
        <Row>
            <Col span={24}>
                <SerialCodeManagementTable keyPrefix={'cataloging.serial_code_management'} permission_level={permission_level} />
            </Col>
        </Row>
    )
}
const SerialCodeManagementTable = ({
    keyPrefix = 'cataloging.serial_code_management',
    rowKey = "id",
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef(null);
    const columns = [
        {
            title: t('name'),
            dataIndex: "label",
            key: "label",
        },
        {
            title: t('description'),
            dataIndex: "description",
            key: "description",
        },
        {
            title: t('numbering_formula'),
            dataIndex: "numberingmethod",
            key: "numberingmethod",
        },
        {
            title: t('display_order'),
            dataIndex: "displayorder",
            key: "displayorder",
        },
    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [axiosMode, setAxiosMode] = useState("get");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record?.[rowKey]
                );
                selectRow = selectRow.filter(
                    (row) => row?.[rowKey] !== record?.[rowKey]
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    };
    const {
        getData,
        postData,
        patchData,
        deleteData,
        ResponseData,
    } = useCRUDController({
        apiRoute: "/koha/serial/numberingpattern",
        onFinish,
        onBefore,
    });
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    useEffect(() => {
        checkAll();
    }, []);
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <ProTableOt
                    rowKey={rowKey}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return getData({
                            ...newParams,
                        });
                    }}
                    toolBarRender={() => {
                        return [];
                    }}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        setSelectedRowKeys,
                        selectedRowsInfo,
                        setSelectedRowsInfo,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={true}
                    propsPatchOnBefore={(record) => {
                        return { ...record }
                    }}
                    PropsPatchForm={<SerialCodeManagementForm

                    />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    let newValue = Object.entries(val).reduce(
                                        (all, [key, value]) =>
                                            !!value ? { ...all, [key]: value } : { ...all, [key]: null },
                                        {}
                                    );
                                    delete newValue['id']
                                    return {
                                        ...newValue,
                                        displayorder: !!val?.displayorder ? val?.displayorder : "0"
                                    }
                                })
                                postData(newData)
                            },
                            patchData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                        displayorder: !!val?.displayorder ? val?.displayorder : "0"

                                    }
                                })
                                patchData(newData)
                            },
                            deleteData: (data) => {
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        displayorder: !!val?.displayorder ? val?.displayorder : "0"
                                    }
                                })
                                deleteData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={permission_level?.permission_level === 1 ? true : false}
                    propsPatchProcess={(record) => {
                        // let newRecord = transformData(record)
                        return { ...record }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={permission_level?.permission_level === 1 ? true : false}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}

                    propsPost={permission_level?.permission_level === 1 ? true : false}
                    // propsPostOnBefore
                    initialValues={{}}
                    propsWidth={1200}
                    formMode={true}

                />
            </Col>
        </Row>
    );
};

const SerialCodeManagementForm = (
    {
        keyPrefix = 'cataloging.serial_code_management',
        propsForm,
        field,
        initialValues,
        defaultValue,
        onFormFinish = () => { },

    }) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [preview_code_form] = Form.useForm();
    const { t } = useTranslation('translation', { keyPrefix })
    const [activeKey, setActiveKey] = useState("serial_code_setting")
    const actionRef = useRef(null);
    const columns = [
        {
            title: t('number'),
            dataIndex: "number",
            key: "number",
        },
        {
            title: t('publication_date'),
            dataIndex: "publication_date",
            key: "publication_date",
        },

    ];
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        values.collection_code = values.collection_code === "0" ? null : values.collection_code
        values.shelving_control_number = values.shelving_control_number ?? null
        onFormFinish({
            ...values,
        });
    };
    const onPreviewFinish = (values) => {
        let serialCodeSettingValues = !!field?.name ? form.getFieldValue(field?.name) : form.getFieldsValue()
        let serialPreviewValues = !!field?.name ? preview_code_form.getFieldValue(field?.name) : preview_code_form.getFieldsValue()
        let paramsValue = {
            ...serialPreviewValues,
            ...serialCodeSettingValues,
        }
        numberingpatternTestController.getData({
            ...paramsValue
        })
    };
    const onValuesChange = (value, { name, type }) => {
        // console.log({ value })
    };
    const resultTable = (htmlstring) => {
        if (!!htmlstring && typeof htmlstring === "string") {
            return parse(htmlstring)
        }
        else {
            return <></>
        }
    }
    const numberingpatternTestController = useCRUDController({ apiRoute: "/koha/serial/numberingpattern/test" })
    useEffect(() => {
        setDataInitialization();
    }, []);

    return (
        <Row>
            <Col span={24}>
                <Tabs
                    onChange={setActiveKey}
                    activeKey={activeKey}
                    items={[
                        {
                            tab: t('serial_code_setting'),
                            key: 'serial_code_setting'
                        },
                        {
                            tab: t('preview_code_settings_display'),
                            key: 'preview_code_settings_display'
                        }
                    ]} />
            </Col>
            <Col span={24}
                hidden={activeKey !== "serial_code_setting"}
            >
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
            <Col
                span={24}
                hidden={activeKey !== "preview_code_settings_display"}
            >
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                        <Row>
                            <Col>
                                <Button
                                    onClick={() => {
                                        preview_code_form.submit()
                                    }}
                                >
                                    {t('generate_preview')}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={14} lg={14} md={14} sm={24} xs={24}>
                        <Form
                            form={preview_code_form}
                            onValuesChange={onValuesChange}
                            onFinish={onPreviewFinish}
                            autoComplete="off"
                        >
                            <Row>
                                <Col span={24}>
                                    <PreviewCodeFormItemComponent
                                        keyPrefix={keyPrefix}
                                        field={field}
                                    // serialCodeSettingValues={field?.name ? form.getFieldValue(field?.name) : form.getFieldsValue()}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col xxl={10} lg={10} md={10} sm={24} xs={24}>
                        {resultTable(numberingpatternTestController?.ResponseData?.data)}
                    </Col>
                </Row>

            </Col>
        </Row>
    );

}
const FormItemComponent = ({ keyPrefix, field, initialValues = {}, options }) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const formatting_options = [
        {
            value: "",
            text: "",
            label: "-"
        },
        {
            value: "dayname",
            text: "Name of day",
            label: t('name_of_day')
        },
        {
            value: "dayabrv",
            text: "Name of day (abbreviated)",
            label: t('name_of_day_abbreviated')
        },
        {
            value: "monthname",
            text: "Name of month",
            label: t('name_of_month')
        },
        {
            value: "monthabrv",
            text: "Name of month (abbreviated)",
            label: t('name_of_month_abbreviated')
        },
        {
            value: "season",
            text: "Name of season",
            label: t('name_of_season')
        },
        {
            value: "seasonabrv",
            text: "Name of season (abbreviated)",
            label: t('name_of_season_abbreviated')
        }
    ]
    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            hidden={true}
                            {...field}
                            name={[field?.name ?? '', 'id']}
                            fieldKey={[field?.fieldKey ?? '', 'id'].join('.')}
                        >
                            <div></div>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            <Col xxl={24} lg={24} md={24} sm={24} xs={24}>
                <Row>
                    <Col xxl={12} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            label={t(`name`)}
                            name={[field?.name ?? '', 'label']}
                            fieldKey={[field?.fieldKey ?? '', 'label'].join('.')}
                            rules={[{ required: true, message: t('please_enter') }]}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xxl={12} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            label={t(`description`)}
                            name={[field?.name ?? '', 'description']}
                            fieldKey={[field?.fieldKey ?? '', 'description'].join('.')}
                            rules={[{ required: true, message: t('please_enter') }]}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xxl={12} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            label={t(`numbering_formula`)}
                            name={[field?.name ?? '', 'numberingmethod']}
                            fieldKey={[field?.fieldKey ?? '', 'numberingmethod'].join('.')}
                            rules={[{ required: true, message: t('please_enter') }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xxl={12} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            {...field}
                            label={t(`display_order`)}
                            name={[field?.name ?? '', 'displayorder']}
                            fieldKey={[field?.fieldKey ?? '', 'displayorder'].join('.')}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[4, 4]}>
                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                <Card
                                    styles={{
                                        padding: 8
                                    }}
                                    title={"X"}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`label`)}
                                                name={[field?.name ?? '', 'label1']}
                                                fieldKey={[field?.fieldKey ?? '', 'label1'].join('.')}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`every`)}
                                                name={[field?.name ?? '', 'every1']}
                                                fieldKey={[field?.fieldKey ?? '', 'every1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`add`)}
                                                name={[field?.name ?? '', 'add1']}
                                                fieldKey={[field?.fieldKey ?? '', 'add1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`when_more_than`)}
                                                name={[field?.name ?? '', 'whenmorethan1']}
                                                fieldKey={[field?.fieldKey ?? '', 'whenmorethan1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`set_back_to`)}
                                                name={[field?.name ?? '', 'setto1']}
                                                fieldKey={[field?.fieldKey ?? '', 'setto1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`formatting`)}
                                                name={[field?.name ?? '', 'numbering1']}
                                                fieldKey={[field?.fieldKey ?? '', 'numbering1'].join('.')}
                                            >
                                                <Select
                                                    allowClear={true}
                                                    placeholder=""
                                                    options={formatting_options}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>

                            {/* Title Y with suffix 2 */}
                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                <Card
                                    styles={{
                                        padding: 8
                                    }}
                                    title={"Y"}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`label`)}
                                                name={[field?.name ?? '', 'label2']}
                                                fieldKey={[field?.fieldKey ?? '', 'label2'].join('.')}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`every`)}
                                                name={[field?.name ?? '', 'every2']}
                                                fieldKey={[field?.fieldKey ?? '', 'every2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`add`)}
                                                name={[field?.name ?? '', 'add2']}
                                                fieldKey={[field?.fieldKey ?? '', 'add2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`when_more_than`)}
                                                name={[field?.name ?? '', 'whenmorethan2']}
                                                fieldKey={[field?.fieldKey ?? '', 'whenmorethan2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`set_back_to`)}
                                                name={[field?.name ?? '', 'setto2']}
                                                fieldKey={[field?.fieldKey ?? '', 'setto2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>

                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`formatting`)}
                                                name={[field?.name ?? '', 'numbering2']}
                                                fieldKey={[field?.fieldKey ?? '', 'numbering2'].join('.')}
                                            >
                                                <Select
                                                    allowClear={true}
                                                    placeholder=""
                                                    options={formatting_options}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>

                            {/* Title Z with suffix 3 */}
                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                <Card
                                    styles={{
                                        padding: 8
                                    }}
                                    title={"Z"}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`label`)}
                                                name={[field?.name ?? '', 'label3']}
                                                fieldKey={[field?.fieldKey ?? '', 'label3'].join('.')}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`every`)}
                                                name={[field?.name ?? '', 'every3']}
                                                fieldKey={[field?.fieldKey ?? '', 'every3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`add`)}
                                                name={[field?.name ?? '', 'add3']}
                                                fieldKey={[field?.fieldKey ?? '', 'add3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`when_more_than`)}
                                                name={[field?.name ?? '', 'whenmorethan3']}
                                                fieldKey={[field?.fieldKey ?? '', 'whenmorethan3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`set_back_to`)}
                                                name={[field?.name ?? '', 'setto3']}
                                                fieldKey={[field?.fieldKey ?? '', 'setto3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={8}
                                                wrapperCol={16}
                                                label={t(`formatting`)}
                                                name={[field?.name ?? '', 'numbering3']}
                                                fieldKey={[field?.fieldKey ?? '', 'numbering3'].join('.')}
                                            >
                                                <Select
                                                    allowClear={true}
                                                    placeholder=""
                                                    options={formatting_options}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

        </Row>
    );
};
const PreviewCodeFormItemComponent = ({
    keyPrefix = 'cataloging.serial_code_management',
    field,
    initialValues = {},
    options,
    serialCodeSettingValues,
    frequencyOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const locale_options = [
        { "value": "afr", "text": "Afrikaans", "title": "", "label": "Afrikaans" },
        { "value": "alb", "text": "Shqip (Albanian)", "title": "", "label": "Shqip (Albanian)" },
        { "value": "amh", "text": "አማርኛ (Amharic)", "title": "", "label": "አማርኛ (Amharic)" },
        { "value": "ara", "text": "لعربية (Arabic)", "title": "", "label": "لعربية (Arabic)" },
        { "value": "arm", "text": "Հայերեն (Armenian)", "title": "", "label": "Հայերեն (Armenian)" },
        { "value": "aze", "text": "Azərbaycan dili (Azerbaijani)", "title": "", "label": "Azərbaycan dili (Azerbaijani)" },
        { "value": "baq", "text": "Euskera (Basque)", "title": "", "label": "Euskera (Basque)" },
        { "value": "bel", "text": "Беларуская мова (Byelorussian)", "title": "", "label": "Беларуская мова (Byelorussian)" },
        { "value": "ben", "text": "বাংলা (Bengali)", "title": "", "label": "বাংলা (Bengali)" },
        { "value": "bul", "text": "Български (Bulgarian)", "title": "", "label": "Български (Bulgarian)" },
        { "value": "cat", "text": "Català (Catalan)", "title": "", "label": "Català (Catalan)" },
        { "value": "chi", "text": "中文 (Chinese)", "title": "", "label": "中文 (Chinese)" },
        { "value": "cre", "text": "Cree", "title": "", "label": "Cree" },
        { "value": "cze", "text": "Čeština (Czech)", "title": "", "label": "Čeština (Czech)" },
        { "value": "dan", "text": "Dansk (Danish)", "title": "", "label": "Dansk (Danish)" },
        { "value": "dut", "text": "Nederlands (Dutch)", "title": "", "label": "Nederlands (Dutch)" },
        { "value": "eng", "text": "English (English)", "title": "", "label": "English (English)" },
        { "value": "est", "text": "Eesti (Estonian)", "title": "", "label": "Eesti (Estonian)" },
        { "value": "fao", "text": "Føroyskt (Faroese)", "title": "", "label": "Føroyskt (Faroese)" },
        { "value": "fin", "text": "Suomi (Finnish)", "title": "", "label": "Suomi (Finnish)" },
        { "value": "fre", "text": "Français (French)", "title": "", "label": "Français (French)" },
        { "value": "geo", "text": "ქართული (Georgian)", "title": "", "label": "ქართული (Georgian)" },
        { "value": "ger", "text": "Deutsch (German)", "title": "", "label": "Deutsch (German)" },
        { "value": "gla", "text": "Gàidhlig (Scottish Gaelic)", "title": "", "label": "Gàidhlig (Scottish Gaelic)" },
        { "value": "glg", "text": "Galego (Galician)", "title": "", "label": "Galego (Galician)" },
        { "value": "gre", "text": "Eλληνικά (Greek, Modern [1453- ])", "title": "", "label": "Eλληνικά (Greek, Modern [1453- ])" },
        { "value": "heb", "text": "עִבְרִית (Hebrew)", "title": "", "label": "עִבְרִית (Hebrew)" },
        { "value": "hin", "text": "हिन्दी (Hindi)", "title": "", "label": "हिन्दी (Hindi)" },
        { "value": "hrv", "text": "Hrvatski (Croatian)", "title": "", "label": "Hrvatski (Croatian)" },
        { "value": "hun", "text": "Magyar (Hungarian)", "title": "", "label": "Magyar (Hungarian)" },
        { "value": "ice", "text": "Íslenska (Icelandic)", "title": "", "label": "Íslenska (Icelandic)" },
        { "value": "iku", "text": "ᐃᓄᒃᑎᑐᑦ (Inuktitut)", "title": "", "label": "ᐃᓄᒃᑎᑐᑦ (Inuktitut)" },
        { "value": "ind", "text": "Bahasa Indonesia (Indonesian)", "title": "", "label": "Bahasa Indonesia (Indonesian)" },
        { "value": "ipk", "text": "Iñupiaq (Inupiaq)", "title": "", "label": "Iñupiaq (Inupiaq)" },
        { "value": "ita", "text": "Italiano (Italian)", "title": "", "label": "Italiano (Italian)" },
        { "value": "jpn", "text": "日本語 (Japanese)", "title": "", "label": "日本語 (Japanese)" },
        { "value": "kan", "text": "ಕನ್ನಡ (Kannada)", "title": "", "label": "ಕನ್ನಡ (Kannada)" },
        { "value": "khm", "text": "ភាសាខ្មែរ (Khmer)", "title": "", "label": "ភាសាខ្មែរ (Khmer)" },
        { "value": "kin", "text": "Ikinyarwanda (Kinyarwanda)", "title": "", "label": "Ikinyarwanda (Kinyarwanda)" },
        { "value": "kor", "text": "한국어 (Korean)", "title": "", "label": "한국어 (Korean)" },
        { "value": "kur", "text": "کوردی (Kurdish)", "title": "", "label": "کوردی (Kurdish)" },
        { "value": "lao", "text": "ພາສາລາວ (Lao)", "title": "", "label": "ພາສາລາວ (Lao)" },
        { "value": "lat", "text": "Latina (Latin)", "title": "", "label": "Latina (Latin)" },
        { "value": "lav", "text": "Latvija (Latvian)", "title": "", "label": "Latvija (Latvian)" },
        { "value": "lit", "text": "Lietuvių (Lithuanian)", "title": "", "label": "Lietuvių (Lithuanian)" },
        { "value": "mao", "text": "Te Reo Māori (Maori)", "title": "", "label": "Te Reo Māori (Maori)" },
        { "value": "mar", "text": "मराठी (Marathi)", "title": "", "label": "मराठी (Marathi)" },
        { "value": "may", "text": "Bahasa melayu (Malay)", "title": "", "label": "Bahasa melayu (Malay)" },
        { "value": "mon", "text": "Mонгол (Mongolian)", "title": "", "label": "Mонгол (Mongolian)" },
        { "value": "mul", "text": "Multiple languages", "title": "", "label": "Multiple languages" },
        { "value": "nep", "text": "नेपाली (Nepali)", "title": "", "label": "नेपाली (Nepali)" },
        { "value": "nno", "text": "Norsk nynorsk (Norwegian nynorsk)", "title": "", "label": "Norsk nynorsk (Norwegian nynorsk)" },
        { "value": "nob", "text": "Norsk bokmål (Norwegian bokmål)", "title": "", "label": "Norsk bokmål (Norwegian bokmål)" },
        { "value": "pbr", "text": "Ekipangwa (Pangwa)", "title": "", "label": "Ekipangwa (Pangwa)" },
        { "value": "per", "text": "فارسى (Persian)", "title": "", "label": "فارسى (Persian)" },
        { "value": "pol", "text": "Polski (Polish)", "title": "", "label": "Polski (Polish)" },
        { "value": "por", "text": "Português (Portuguese)", "title": "", "label": "Português (Portuguese)" },
        { "value": "prs", "text": "درى (Dari)", "title": "", "label": "درى (Dari)" },
        { "value": "rum", "text": "Română (Romanian)", "title": "", "label": "Română (Romanian)" },
        { "value": "rus", "text": "Русский (Russian)", "title": "", "label": "Русский (Russian)" },
        { "value": "slo", "text": "Slovenčina (Slovak)", "title": "", "label": "Slovenčina (Slovak)" },
        { "value": "slv", "text": "Slovenščina (Slovene)", "title": "", "label": "Slovenščina (Slovene)" },
        { "value": "snd", "text": "سنڌي (Sindhi)", "title": "", "label": "سنڌي (Sindhi)" },
        { "value": "spa", "text": "Español (Spanish)", "title": "", "label": "Español (Spanish)" },
        { "value": "srp", "text": "Cрпски (Serbian)", "title": "", "label": "Cрпски (Serbian)" },
        { "value": "swa", "text": "Kiswahili (Swahili)", "title": "", "label": "Kiswahili (Swahili)" },
        { "value": "swe", "text": "Svenska (Swedish)", "title": "", "label": "Svenska (Swedish)" },
        { "value": "tam", "text": "தமிழ் (Tamil)", "title": "", "label": "தமிழ் (Tamil)" },
        { "value": "tet", "text": "Tetun (Tetum)", "title": "", "label": "Tetun (Tetum)" },
        { "value": "tgl", "text": "Tagalog (Tagalog)", "title": "", "label": "Tagalog (Tagalog)" },
        { "value": "tha", "text": "ภาษาไทย (Thai)", "title": "", "label": "ภาษาไทย (Thai)" },
        { "value": "tur", "text": "Türkçe (Turkish)", "title": "", "label": "Türkçe (Turkish)" },
        { "value": "ukr", "text": "Українська (Ukrainian)", "title": "", "label": "Українська (Ukrainian)" },
        { "value": "und", "text": "Undetermined", "title": "", "label": "Undetermined" },
        { "value": "urd", "text": "اردو (Urdu)", "title": "", "label": "اردو (Urdu)" },
        { "value": "vie", "text": "Tiếng Việt (Vietnamese)", "title": "", "label": "Tiếng Việt (Vietnamese)" },
        { "value": "yid", "text": "יידיש (Yiddish)", "title": "", "label": "יידיש (Yiddish)" },
        { "value": "zxx", "text": "No linguistic content", "title": "", "label": "No linguistic content" }
    ]
    const frequencyController = useCRUDController({ apiRoute: "/koha/serial/periodicity" });
    useEffect(() => {
        if (!frequencyOptions) {
            frequencyController.getData({})
        }
    }, [])

    return (
        <Row gutter={[16, 16]}>
            {/* <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'id']}
                            fieldKey={[field?.fieldKey ?? '', 'id'].join('.')}
                        >
                            <div></div>
                        </Form.Item>
                    </Col>
                </Row>
            </Col> */}
            <Col xxl={24} lg={24} md={24} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    {...field}
                                    labelCol={8}
                                    wrapperCol={16}
                                    label={t(`frequency`)}
                                    name={[field?.name ?? '', 'frequency']}
                                    fieldKey={[field?.fieldKey ?? '', 'frequency'].join('.')}
                                    rules={[{ required: true, message: t('please_enter') }]}

                                >
                                    <Select options={
                                        !!frequencyOptions &&frequencyOptions.length > 0 ?
                                            (frequencyOptions)?.map((value) => {
                                                return {
                                                    label: value?.description,
                                                    value: value?.id
                                                }
                                            })
                                            :
                                            (frequencyController?.ResponseData)?.map((value) => {
                                                return {
                                                    label: value?.description,
                                                    value: value?.id
                                                }
                                            })} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    {...field}
                                    labelCol={8}
                                    wrapperCol={16}
                                    label={t(`first_issue_publication_date`)}
                                    name={[field?.name ?? '', 'firstacquidate']}
                                    fieldKey={[field?.fieldKey ?? '', 'firstacquidate'].join('.')}
                                    rules={[{ required: true, message: t('please_enter') }]}
                                >
                                    <Input type="date" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item
                                            {...field}
                                            labelCol={16}
                                            wrapperCol={8}
                                            label={t(`subscription_length`)}
                                            name={[field?.name ?? '', 'sublength']}
                                            fieldKey={[field?.fieldKey ?? '', 'sublength'].join('.')}
                                            rules={[{ required: true, message: t('please_enter') }]}
                                        >
                                            <InputNumber max={999} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            {...field}
                                            label={null}
                                            name={[field?.name ?? '', 'subtype']}
                                            fieldKey={[field?.fieldKey ?? '', 'subtype'].join('.')}
                                            rules={[{ required: true, message: t('please_enter') }]}
                                        >
                                            <Select options={[
                                                {
                                                    label: "期",
                                                    value: "issues"
                                                },
                                                {
                                                    label: "週",
                                                    value: "weeks"
                                                },
                                                {
                                                    label: "月",
                                                    value: "months"
                                                },
                                            ]} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    {...field}
                                    labelCol={8}
                                    wrapperCol={16}
                                    label={t(`locale`)}
                                    name={[field?.name ?? '', 'locale']}
                                    fieldKey={[field?.fieldKey ?? '', 'locale'].join('.')}
                                    rules={[{ required: true, message: t('please_select') }]}
                                >
                                    <Select
                                        options={locale_options}
                                    >

                                    </Select>
                                </Form.Item>
                            </Col>

                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <Row gutter={[4, 4]}>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                        <Card
                                            styles={{
                                                padding: 2
                                            }}
                                            title={"X"}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={8}
                                                        wrapperCol={16}
                                                        label={t(`begins_with`)}
                                                        name={[field?.name ?? '', 'lastvalue1']}
                                                        fieldKey={[field?.fieldKey ?? '', 'lastvalue1'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={8}
                                                        wrapperCol={16}
                                                        label={t(`inner_counter`)}
                                                        name={[field?.name ?? '', 'innerloop1']}
                                                        fieldKey={[field?.fieldKey ?? '', 'innerloop1'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    {/* Title Y with suffix 2 */}
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                        <Card
                                            styles={{
                                                padding: 2
                                            }}
                                            title={"Y"}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={8}
                                                        wrapperCol={16}
                                                        label={t(`begins_with`)}
                                                        name={[field?.name ?? '', 'lastvalue2']}
                                                        fieldKey={[field?.fieldKey ?? '', 'lastvalue2'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={8}
                                                        wrapperCol={16}
                                                        label={t(`inner_counter`)}
                                                        name={[field?.name ?? '', 'innerloop2']}
                                                        fieldKey={[field?.fieldKey ?? '', 'innerloop2'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    {/* Title Z with suffix 3 */}
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                        <Card
                                            styles={{
                                                padding: 2
                                            }}
                                            title={"Z"}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={8}
                                                        wrapperCol={16}
                                                        label={t(`begins_with`)}
                                                        name={[field?.name ?? '', 'lastvalue3']}
                                                        fieldKey={[field?.fieldKey ?? '', 'lastvalue3'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={8}
                                                        wrapperCol={16}
                                                        label={t(`inner_counter`)}
                                                        name={[field?.name ?? '', 'innerloop3']}
                                                        fieldKey={[field?.fieldKey ?? '', 'innerloop3'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Col>

        </Row>
    );
};
export default SerialCodeManagement
export { SerialCodeManagementTable, SerialCodeManagementForm, PreviewCodeFormItemComponent }
